import { useTranslation } from 'react-i18next';
import { ControlsGroup } from '../components/controlsGroup';
import { PanelContainer } from '../components/panelContainer';
import { CheckboxSettings } from './settingsInputs/CheckboxSettings';
import { SettingsInput } from './settingsInputs/settingsInput';
import { useContextSelector } from 'use-context-selector';
import { FormConfigContext } from '../../uiEditor/formConfigContext/formConfig.provider';

export const GeneralSettings = () => {
  const { t } = useTranslation('dev');
  const { saveFormOptions, setSaveFormOptions } = useContextSelector(FormConfigContext, (x) => x);

  return (
    <PanelContainer header={'General form settings'} expanded>
      <ControlsGroup flexible header={t('StudySettingsPage.FormBuilder.topbar.NewFormModal.Label')}>
        <SettingsInput
          value={saveFormOptions?.type}
          onChange={(e) => setSaveFormOptions?.((x) => ({ ...x, type: e.target.value }))}
        />
      </ControlsGroup>

      <ControlsGroup flexible>
        <CheckboxSettings
          label={t('StudySettingsPage.FormBuilder.topbar.multiInstance')}
          isChecked={!!saveFormOptions?.isMultiInstance}
          setValue={(newValue) =>
            setSaveFormOptions?.((x) => ({
              ...x,
              isMultiInstance: newValue,
              allowedForNotStartedPatients: !!newValue ? undefined : false,
            }))
          }
        />

        <CheckboxSettings
          label={t('StudySettingsPage.FormBuilder.topbar.allowedForNotStartedPatients')}
          isChecked={!!saveFormOptions?.allowedForNotStartedPatients}
          disabled={!saveFormOptions?.isMultiInstance}
          setValue={(newValue) => setSaveFormOptions?.((x) => ({ ...x, allowedForNotStartedPatients: newValue }))}
        />

        <CheckboxSettings
          label={t('StudySettingsPage.FormBuilder.topbar.patientCreation')}
          isChecked={!!saveFormOptions?.isPatientCreationForm}
          setValue={(newValue) => setSaveFormOptions?.((x) => ({ ...x, isPatientCreationForm: newValue }))}
        />

        <CheckboxSettings
          label={t('StudySettingsPage.FormBuilder.topbar.canBeSkipped')}
          isChecked={!!saveFormOptions?.canBeSkipped}
          setValue={(newValue) => setSaveFormOptions?.((x) => ({ ...x, canBeSkipped: newValue }))}
        />
      </ControlsGroup>
    </PanelContainer>
  );
};
